import * as React from "react"
import { Outlet } from "react-router-dom"
import { AppSidebar } from "@/components/app-sidebar"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { getAuth } from "@/lib/auth"

export function AppLayout() {
  const auth = getAuth()

  const user = {
    name: auth ? `${auth.user.firstName} ${auth.user.lastName}` : "Usuario",
    email: auth?.user.email ?? "",
    avatar: "",
  }
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 72)",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" user={user} />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
